import { environment } from '../environments/environment';

export const MIN_AGE_OPTIN = 14;
export const MAX_AGE_OPTIN = 80;

export const languages = [
    {
        key: 'en',
        value: 'English',
    },
    {
        key: 'de',
        value: 'Deutsch',
    },
];

export const CONTACT_INFO = {
    imprintPhone: '040 752 901 600',
    phone: '040 752 901 600',
    email: 'kontakt@finstein.de',
    fax: '040 752 901 603',
};

export const DEFAULT_LANGUAGE = 'de';
export const DE_LANGUAGE = 'de';
export const EN_LANGUAGE = 'en';

export const BRANCHS = [
    'Beratung/Consulting',
    'Bildung',
    'Chemie',
    'Dienstleistung',
    'Druck/Verpackung',
    'IT',
    'Einkauf',
    'Elektro/Elektronik',
    'Energie',
    'Finanz',
    'Forschung/Entwicklung',
    'Gesundheit/Soziales/Pflege',
    'Handel',
    'Handwerk',
    'Immobilien',
    'Industrie',
    'Internet',
    'Kunst/Kultur',
    'Marketing/Werbung/PR',
    'Marktforschung',
    'Maschinenbau',
    'Medien',
    'Medizin/Pharma',
    'Medizintechnik',
    'Nahrungsmittel/Landwirtschaft',
    'Personalwesen & -beschaffung',
    'Recht',
    'Seminare/Messen',
    'Sonstige Branchen',
    'Sport/Beauty',
    'Steuerberatung/Wirtschaftsprüfung',
    'Telekommunikation',
    'Textil',
    'Tourismus/Gastronomie',
    'Vereine',
    'Transport/Verkehr/Logistik',
    'Versicherung',
    'Öffentliche Verwaltung',
];

export const STATES = [
    'Baden-Württemberg',
    'Bayern',
    'Berlin',
    'Brandenburg',
    'Bremen',
    'Hamburg',
    'Hessen',
    'Mecklenburg-Vorpommern',
    'Niedersachsen',
    'Nordrhein-Westfalen',
    'Rheinland-Pfalz',
    'Saarland',
    'Sachsen',
    'Sachsen-Anhalt',
    'Schleswig-Holstein',
    'Thüringen',
];

export const MODES_OF_TRANSPORT = ['car', 'other'];

export const RELATIONSHIP_TYPES = ['spouse', 'registered-life-partner', 'kind'];
export const ONLY_CHILD_RELATIONSHIP = ['kind'];

export const BAV_DENIED = 'BAV_DENIED';

export const MIN_WIDTH_SUPPORT = '1366px';
export const MIN_HEIGHT_SUPPORT = '768px';

/**
 * Firebase data
 */
export const FIREBASE_REGION = 'europe-west1';
export const FIREBASE_URL_LOCAL_FUNCTIONS = 'http://localhost:5001';
export const FIREBASE_URL_FUNCTIONS = `https://${FIREBASE_REGION}-${environment.firebaseConfig.projectId}.cloudfunctions.net/`;
export const FIREBASE_STORAGE_BUCKET_BASE_URL = `https://firebasestorage.googleapis.com/v0/b/${environment.firebaseConfig.storageBucket}/o/`;

/**
 * Firebase functions
 */
export const GET_EMPLOYEE_BENEFITS_SERVICES = 'getEmployeeBenefitsServices';
export const CREATE_REPORT_FUNCTION = 'createReport';
export const COMPANY_ADVANTAGE_CALCULATE_FUNCTION = 'companyAdvantageCalculate';
export const CREATE_COMPANY_LEAD = 'addCompanyLead';
export const SEND_CONTACT_FORM = 'sendContactForm';
export const FAQ_REQUEST_RESET_PASSWORD_FUNCTION = 'faqRequestResetPassword';
export const FAQ_CHANGE_PASSWORD_FUNCTION = 'faqChangePassword';
export const COP_REQUEST_RESET_PASSWORD_FUNCTION =
    'employeeRequestResetPassword';
export const COP_CHANGE_PASSWORD_FUNCTION = 'employeeChangePassword';
export const GET_EMPLOYEE_BY_RESET_PASSWORD_KEY =
    'getEmployeeByResetPasswordKey';
export const GET_COMPANY_LEAD_BY_RESET_PASSWORD_KEY =
    'getCompanyLeadByResetPasswordKey';
export const CREATE_REQUEST_OPTIN = 'createRequestOptin';
export const INVITE_OPTIN_VALIDATION = 'inviteOptinValidation';
export const GET_OPTIN_DATA_BY_ID = 'getOptinDataById';
export const CONFIRM_OPTIN_REGISTRATION_BY_EMPLOYEE =
    'confirmOptinRegistrationByEmployee';
export const UPDATE_PERSON_SMARTPHONE_DATA = 'updatePersonSmartphoneData';
export const UPDATE_EMPLOYEE_FORM_DATA = 'updateEmployeeFormData';
export const RESET_CURRENT_STORE_CART = 'resetCurrentStoreCart';
export const UPDATE_SERVICE_SELECTION_FUNCTION = 'updateServiceSelection';
export const EMPLOYEE_ADVANTAGE_CALCULATE_FUNCTION =
    'employeeAdvantageCalculate';
export const GET_PRODUCTS_FOR_EMPLOYEE_FUNCTION = 'getProductsForEmployee';
export const CONFIRM_COP_FINALIZATION = 'confirmCopFinalization';
export const GENERATE_CONTRACT_PREVIEW = 'generateContractPreview';
export const RECAPTCHA_VALIDATOR_FUNCTION = 'recaptchaValidator';
export const FAQ_PROCESS_INITIALIZED_FUNCTION = 'faqProcessInitialized';
export const CREATE_SUPPORT_REQUEST_FUNCTION = 'createSupportRequest';
export const CONFIRM_COP_WITHOUT_OPTIMIZATION_FUNCTION =
    'confirmCopWithoutOptimization';

/**
 * Firebase query operators
 */
export const OP_ARRAY_CONTAINS = 'array-contains';
export const OP_EQUALS = '==';
export const OP_IN = 'in';

/**
 * Local Storage keys
 */
export const LANG_KEY_LOCAL_STORAGE_KEY = 'langKey';
export const ALLOW_COOKIES_LOCAL_STORAGE_KEY = 'allowCookies';
export const USER_LOCAL_STORAGE_KEY = 'user';

/**
 * Firebase collections
 */
export const USERS_COLLECTION = 'users';
export const COMPANY_LEADS_COLLECTION = 'company-leads';
export const EMPLOYEES_COLLECTION = 'employees';
export const TESTIMONIALS_COLLECTION = 'testimonials';
export const COMPANIES_COLLECTION = 'companies';
export const OPTINS_COLLECTION = 'optins';
export const ADDRESSES_COLLECTION = 'addresses';
export const BENEFITS_SERVICES_COLLECTION = 'benefits-services';
export const COLLECTION_OPTIN_IMPORTED_DATA = 'optin-imported-data';
export const COLLECTION_CONSULTANCY_PROCESS = 'consultancy-process';
export const COLLECTION_PRODUCTS = 'products';
export const COLLECTION_STORE_CART = 'store-cart';
export const COLLECTION_GENERAL = 'general';
export const VIDEO_GALLERY_COLLECTION = 'video-gallery';
export const SERVICES_COLLECTION = 'services';
export const PARTNER_COMPANIES_COLLECTION = 'partner-companies';

/**
 * Patterns
 */
export const EMAIL_REGEX = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$';

/**
 * System's status
 */
export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_APPROVED = 'APPROVED';
export const STATUS_DATA_COMPLETED = 'DATA COMPLETED';
export const STATUS_DATA_EXPORT_PENDING = 'DATA_EXPORT_PENDING';
export const STATUS_PENDING_OPTIN = 'PENDING_OPTIN';
export const STATUS_REJECTED = 'REJECTED';
export const STATUS_INACTIVE = 'INACTIVE';
export const STATUS_PENDENT = 'PENDENT';
export const STATUS_OUT_OF_RANGE = 'OUT_OF_RANGE';
export const STATUS_FULL = 'FULL';
export const STATUS_DISABLED = 'DISABLED';
export const STATUS_DISABLED_BY_MOBILE_CONTRACT = 'DISABLED_BY_MOBILE_CONTRACT';
export const READY_FOR_CONSULTATION_PROCESS = 'READY_FOR_CONSULTATION_PROCESS';
export const IN_THE_CONSULTING_PROCESS = 'IN_THE_CONSULTING_PROCESS';
export const MINIMUM_WAGE_NOT_REACHED = 'MINIMUM_WAGE_NOT_REACHED';
export const FINALIZED_WITHOUT_OPTIMIZATION = 'FINALIZED_WITHOUT_OPTIMIZATION';
/**
 * Video URLS
 */
export const WEBSITE_VIDEOS_PREFIX = `${FIREBASE_STORAGE_BUCKET_BASE_URL}website-videos%2F`;
export const OPTIN_FORM_PREFIX = `${WEBSITE_VIDEOS_PREFIX}public%2Foptin-form%2F`;

/**
 * FAQ steps index
 */
export const FAQ_WELCOME_STEP_INDEX = 0;
export const FAQ_CALCULATOR_RESULT_OUTPUT_STEP_INDEX = 1;
export const FAQ_SECTION_STEP_INDEX = 2;
export const FAQ_PERSONAL_CALL_STEP_INDEX = 3;

/**
 * COP steps index
 */
export const COP_WELCOME_STEP_INDEX = 0;
export const COP_QUESTIONS_AND_ANSWERS_STEP_INDEX = 1;
export const COP_NET_BENEFIT_HOME_STEP_INDEX = 2;
export const COP_EMPLOYEE_FORM_STEP_INDEX = 3;
export const COP_SMARTPHONE_COLLECT_PERSON_LIST_STEP_INDEX = 4;
export const COP_DETERMINE_NET_BENEFIT_HOME_STEP_INDEX = 5;
export const COP_IMPORTANT_INFO_STEP_INDEX = 6;
export const COP_SERVICES_SELECTION_STEP_INDEX = 7;
export const COP_SUMMARY_SERVICES_SELECTION_STEP_INDEX = 8;
export const COP_CONFIRM_NO_SERVICES_SELECTION_STEP_INDEX = 9;
export const COP_DISTRIBUTE_NET_BENEFIT_WELCOME_STEP_INDEX = 10;
export const COP_SELECTION_SLIDER_STEP_INDEX = 11;
export const COP_DISTRIBUTING_CONFIRMATION_TABLE_STEP_INDEX = 12;
export const COP_NOT_POSSIBLE_TO_CHOOSE_SMARTPHONE_STEP_INDEX = 13;
export const COP_STORE_WELCOME_STEP_INDEX = 14;
export const COP_FAMILY_MEMBER_LIST_STEP_INDEX = 15;
export const COP_STORE_SUMMARY_STEP_INDEX = 16;
export const COP_STORE_NO_SMARTPHONE_ALLOWED_STEP_INDEX = 17;
export const COP_CONTRACT_PREVIEW_STEP_INDEX = 18;
export const COP_FINALIZATION_STEP_INDEX = 19;

// Max values
export const COP_MAX_WORKING_DAYS_PEY_WEEK = 7;
export const COP_MAX_WORK_DISTANCE_IN_KM = 400;
export const COP_MAX_MONTHLY_COSTS_PUBLIC_TRANSPORT = 500;

// Services of group one
export const SERVICE_MOBILE = 'mobile';
export const SERVICE_MOBILE_CONTRACT = 'mobile-contract';
export const SERVICE_EMPLOYEE_DISCOUNT = 'employee-discount';
export const SERVICE_RECREATIONAL_ACTIVITIES = 'recreational-activities';
export const SERVICE_RESTAURANT = 'restaurant';
export const SERVICE_CASH_REGISTER = 'cash-register';
export const SERVICE_HARDWARE = 'hardware';
export const SERVICE_RETIREMENT = 'retirement';
export const SERVICE_SALARY_INCREASE_SUMMARY = 'salary-increase';
export const SERVICE_JOB_TICKET = 'job-ticket';

// Services of group two
export const SERVICE_COUPON = 'coupon';
export const SERVICE_COMMUTE = 'commute';
export const SERVICE_BIRTHDAY = 'birthday';
export const SERVICE_INTERNET = 'internet';
export const SERVICE_COMPANY_ADVERTISING = 'company-advertising';
export const SERVICE_CHILDCARE = 'childcare';

export const SERVICES_GROUP_1 = [
    SERVICE_MOBILE,
    SERVICE_MOBILE_CONTRACT,
    SERVICE_EMPLOYEE_DISCOUNT,
    SERVICE_RECREATIONAL_ACTIVITIES,
    SERVICE_RESTAURANT,
    SERVICE_CASH_REGISTER,
    SERVICE_JOB_TICKET,
];
export const SERVICES_GROUP_2 = [
    SERVICE_COUPON,
    SERVICE_COMMUTE,
    SERVICE_BIRTHDAY,
    SERVICE_INTERNET,
    SERVICE_COMPANY_ADVERTISING,
    SERVICE_CHILDCARE,
];

export const LINKEDIN_CONVERSION_ID_VIDEO_TEASER_CLICKED = 18839153;
export const LINKEDIN_CONVERSION_ID_DEMO_MEETING_CONFIRMED = 18292249;
export const LINKEDIN_CONVERSION_ID_MEETING_FORM_CONFIRMED = 18839145;
export const LINKEDIN_CONVERSION_ID_INTERESSSIERT_FORM_CONFIRMED = 18839161;

export const MEAL_FRINGE_BENEFIT_VALUE = 4.13; // "Sachbezugswert" for meals to be flat rate taxed
export const MEAL_EMPLOYEE_CONTRIBUTION = 3.1; // value for the tax free employer contribution

export const MAX_VALUE_FREQUENCY_BUY_MEALS = 7;
export const MAX_VALUE_AVG_FREQUENCY_BUSINESS_TRIP = 31;
export const MAX_VALUE_SERVICE_RESTAURANT_PER_DAY =
    MEAL_FRINGE_BENEFIT_VALUE + MEAL_EMPLOYEE_CONTRIBUTION;
export const MAX_VALUE_SERVICE_RESTAURANT_DAYS_PER_MONTH = 15;
export const YEAR_MONTH_QUANTITY = 12;
export const AGE_TO_RETIRE = 67;
export const MAX_VALUE_SERVICE_BUY_GOODS_MAX_ALLOWED = 90;
export const MAX_VALUE_INTERNET_COSTS = 50;
export const MAX_VALUE_PHONE_CONTRACT_COSTS = 200;
export const MAX_VALUE_CHILD_COSTS = 1500.0;

export const MINIMUM_BAV_SELECTION_VALUE = 30;

export const PERSON_AGE_LIMIT_FOR_SMARTPHONE = 12;

export const MAXIMUM_AGE_BAV = 62; // 1960
export const MINIMUM_BAV_PAYMENT = 30;
export const MAXIMUM_BAV_DEPOSIT = 292;

/* Auth params */
export const AUTH_EXP_KEY = '_expiredTime';
export const AUTH_EXPIRATION_TIME = environment.authExpirationTime;
export const AUTH_RECOVERY_TIME = environment.authRecoveryTime;
export const INACTIVE_MODAL_ID = 'inactive-close-modal';
export const INACTIVE_PING_CHECK = 60;

/**
 * Response code error constants
 */
export const RESP_CODE_OK = 'ok';
export const RESP_CODE_ALREADY_EXISTS = 'already-exists';

/**
 * Analytics constants
 */
export const GTAG_KEY = 'G-YFMDH3G8KT';
export const FB_PIXEL_KEY = '678301010575334';

export const SERVICES_SECTION1 = [
    {
        id: 'childcare',
        status: 'ACTIVE',
        nameDe: 'Kindergarten-Baustein',
        nameEn: 'Kindergarten Benefit',
        descriptionDe:
            'Der Kindergarten-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile bei den Kosten für die Kindergartenbetreuung.',
        descriptionEn:
            'The kindergarten module gives your employees net advantages in terms of the costs for kindergarten care',
        icon: 'assets%2Ficons%2Fservice-childcare.svg?alt=media&token=f99e0d5a-4360-4ad2-9400-5efac0e39d60',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="53.004" height="40.331"><g data-name="Group 26645" fill="none" stroke="#5689a3" stroke-width="1.3"><path data-name="Union 75" d="M43.958 39.654c-.177 0-.459-.328-.493-.532a9.508 9.508 0 01-.023-1.459h-7.5l-.114 1.949h-5.88V28.277c-.843.734-1.525 1.3-2.174 1.9-2.946 2.7-5.911 5.389-8.8 8.145a3.3 3.3 0 01-2.566.756c-4.119-.013-8.239-.045-12.359-.059-.869 0-1.74.037-2.609.068-.7.025-.968-.288-.642-.883a36.17 36.17 0 012.307-3.931 5.369 5.369 0 014.969-2.21 5.517 5.517 0 004.809-1.986c3.84-3.887 7.942-7.536 11.805-11.4 1.265-1.266 2.51-2.011 4.334-1.7a2.7 2.7 0 00.6-.013 1.631 1.631 0 00.269-.084v-3.02h-2.807c0-1.417-.044-2.728.034-4.033.017-.289.42-.613.719-.822 3.921-2.74 7.85-5.454 11.84-8.213 2.033 1.4 4.067 2.782 6.089 4.184s4.056 2.83 6.072 4.262c.216.155.48.422.488.645.046 1.278.023 2.559.023 3.94H49.47v25.855h-2.447c-1.036.003-2.051-.002-3.065-.024zm-8.015-18.319h7.415v-7.419h-7.415z"/><path data-name="Line 88" stroke-linecap="round" d="M34.219 27.472h11.256"/><path data-name="Line 89" stroke-linecap="round" d="M34.219 29.973h11.256"/><path data-name="Line 90" stroke-linecap="round" d="M34.219 32.474h11.256"/></g></svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="52.109" height="40.809" viewBox="0 0 52.109 40.809">   <path id="Caminho_61424" data-name="Caminho 61424" d="M-2707.507,205.849a1.134,1.134,0,0,0-.492-.676q-3.047-2.256-6.12-4.473c-2.038-1.472-4.088-2.926-6.136-4.391-4.022,2.9-7.985,5.744-11.934,8.61-.3.219-.708.559-.726.863-.078,1.369-.034,2.745-.034,4.231h2.828v3.17a1.531,1.531,0,0,1-.272.087,2.625,2.625,0,0,1-.606.015c-1.839-.325-3.093.456-4.369,1.785-3.9,4.057-8.028,7.885-11.9,11.964a5.46,5.46,0,0,1-4.847,2.085,5.327,5.327,0,0,0-5.009,2.318,38.555,38.555,0,0,0-2.325,4.125c-.33.624-.061.952.647.927.876-.032,1.753-.074,2.63-.071,4.152.015,8.3.049,12.458.062a3.238,3.238,0,0,0,2.586-.793c2.915-2.892,5.9-5.71,8.873-8.547.655-.626,1.342-1.219,2.192-1.989v11.894h5.93c.04-.714.077-1.369.115-2.045h7.557a10.246,10.246,0,0,0,.024,1.531c.033.215.319.554.5.558,1.813.041,3.628.025,5.558.025V209.984h2.9C-2707.484,208.534-2707.46,207.19-2707.507,205.849Zm-16.512,4.233h7.476v7.784h-7.476Zm9.989,21.176a.433.433,0,0,1-.432.432h-11.4a.433.433,0,0,1-.432-.432v-.586a.434.434,0,0,1,.432-.432h11.4a.433.433,0,0,1,.432.432Zm0-3.5a.433.433,0,0,1-.432.432h-11.4a.433.433,0,0,1-.432-.432v-.586a.434.434,0,0,1,.432-.432h11.4a.433.433,0,0,1,.432.432Zm0-3.544a.433.433,0,0,1-.432.432h-11.4a.434.434,0,0,1-.432-.432v-.586a.433.433,0,0,1,.432-.432h11.4a.433.433,0,0,1,.432.432Z" transform="translate(2759.587 -196.309)" fill="#0e3f92"/> </svg>',
        welcomeHome: {
            incomeTaxDe: 'frei',
            descriptionEn:
                'Make it easier for your employees to find a balance between family and work. With the kindergarten module, you support your employees with the costs of kindergarten care.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Kindergarten',
            additionalityReq: true,
            maxAmountDe: 'unbegrenzt',
            incomeTaxEn: 'free',
            legalBasis: '§ 3 Nr. 33 EStG; R 3.33 LStR',
            descriptionDe:
                'Erleichtern Sie Ihren Mitarbeitern die Balance zwischen Familie und Beruf.  Mit dem Kindergarten-Baustein unterstützen Sie Ihre Mitarbeiter bei den Kosten für die Kindergartenbetreuung.',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Kindergarten',
            maxAmountEn: 'unlimited',
        },
    },
    {
        id: 'commute',
        status: 'ACTIVE',
        nameDe: 'Arbeitsweg-Baustein',
        nameEn: 'Commuting Benefit',
        descriptionDe:
            'Der Arbeitsweg-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile in Bezug auf deren Arbeitsweg. Hierzu zählen alle Entfernungen, die auf dem Weg zur Arbeit nicht mit öffentlichen Verkehrsmitteln zurücklegt werden.',
        descriptionEn:
            'The commute module gives your employees net benefits in relation to their commuting. This includes all distances that are not covered by public transport on the way to work.',
        icon: 'assets%2Ficons%2Fservice-commute.svg?alt=media&token=b10a89e2-b30e-484a-9391-b9d664a835a1',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="48.229" height="50.389"><g data-name="Group 26636"><g data-name="Group 26239" transform="translate(17699.858 251.389)"><path data-name="Path 39552" d="M-17687.375-223.106h6.148a4.067 4.067 0 014.067 4.067h0a4.067 4.067 0 01-4.067 4.067h-8.896c-2.246 0-4.994 2.762-4.95 4.519v2.246c0 2.246 2.7 4.207 4.95 4.207h22.647" fill="none" stroke="#5689a3" stroke-miterlimit="10" stroke-width="2" stroke-dasharray="2"/><path data-name="Subtraction 161" d="M-17664.598-208.01h0a154.113 154.113 0 01-6.16-9.466 79.6 79.6 0 01-4.235-7.943 17.943 17.943 0 01-1.925-6.626 12.237 12.237 0 013.608-8.712 12.239 12.239 0 018.713-3.609 12.239 12.239 0 018.711 3.609 12.242 12.242 0 013.607 8.712 17.943 17.943 0 01-1.925 6.626 79.441 79.441 0 01-4.234 7.943 154.435 154.435 0 01-6.158 9.466zm.121-29.5a5.271 5.271 0 00-3.729 1.528 5.074 5.074 0 00-1.53 3.682 5.513 5.513 0 001.59 3.782 5.172 5.172 0 003.736 1.632 5.045 5.045 0 003.55-1.484 5.482 5.482 0 001.582-3.794 5.271 5.271 0 00-1.452-3.786 5.214 5.214 0 00-3.747-1.56z" fill="none" stroke="#5689a3" stroke-miterlimit="10" stroke-width="1.3"/><path data-name="Subtraction 162" d="M-17691.185-227.064h0a100.599 100.599 0 01-4.011-6.164c-1.83-3.064-4.012-7.2-4.012-9.487a8.033 8.033 0 018.023-8.023 8.031 8.031 0 018.021 8.023c0 2.289-2.181 6.422-4.01 9.487-1.964 3.289-3.928 6.048-4.01 6.164zm.08-19.208a3.436 3.436 0 00-2.43 1 3.311 3.311 0 00-1 2.4 3.584 3.584 0 001.035 2.463 3.367 3.367 0 002.433 1.062 3.289 3.289 0 002.312-.965 3.584 3.584 0 00.086-4.937 3.394 3.394 0 00-2.437-1.014z" fill="none" stroke="#5689a3" stroke-miterlimit="10" stroke-width="1.3"/><circle data-name="Ellipse 3493" cx="2" cy="2" r="2" transform="translate(-17693 -225)" fill="#5689a3"/><circle data-name="Ellipse 3494" cx="2.5" cy="2.5" r="2.5" transform="translate(-17667 -206)" fill="#5689a3"/></g></g></svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="46.184" height="48.39" viewBox="0 0 46.184 48.39">   <g id="Grupo_26239" data-name="Grupo 26239" transform="translate(0.5 0.5)">     <path id="Caminho_39552" data-name="Caminho 39552" d="M2312.461,3809.255h5.92a3.916,3.916,0,0,1,3.916,3.916h0a3.916,3.916,0,0,1-3.916,3.916h-8.561c-2.162,0-4.809,2.659-4.766,4.351v2.163c0,2.162,2.6,4.051,4.766,4.051h21.806" transform="translate(-2301.069 -3782.649)" fill="none" stroke="#417deb" stroke-miterlimit="10" stroke-width="2" stroke-dasharray="2"/>     <path id="Subtração_161" data-name="Subtração 161" d="M11.862,35.007h0c-.03-.042-3.019-4.239-5.93-9.115a76.51,76.51,0,0,1-4.077-7.649A17.283,17.283,0,0,1,0,11.862,11.862,11.862,0,0,1,20.25,3.474a11.785,11.785,0,0,1,3.474,8.388,17.282,17.282,0,0,1-1.854,6.38,76.506,76.506,0,0,1-4.078,7.649c-2.91,4.874-5.9,9.073-5.931,9.115ZM11.982,6.6A5.08,5.08,0,0,0,8.39,8.073a4.893,4.893,0,0,0-1.473,3.545,5.306,5.306,0,0,0,1.53,3.642,4.984,4.984,0,0,0,3.6,1.573,4.857,4.857,0,0,0,3.417-1.43,5.3,5.3,0,0,0,.125-7.3A5.022,5.022,0,0,0,11.982,6.6Z" transform="translate(21.46 6.135)" fill="#0e3f92" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>     <path id="Subtração_162" data-name="Subtração 162" d="M7.724,22.794h0c-.08-.111-1.97-2.766-3.861-5.934C2.1,13.907,0,9.927,0,7.724a7.724,7.724,0,1,1,15.447,0c0,2.2-2.1,6.183-3.862,9.134C9.694,20.026,7.8,22.681,7.724,22.793ZM7.8,4.3a3.308,3.308,0,0,0-2.338.958A3.186,3.186,0,0,0,4.5,7.565a3.456,3.456,0,0,0,1,2.371A3.246,3.246,0,0,0,7.843,10.96a3.164,3.164,0,0,0,2.226-.93,3.436,3.436,0,0,0,.991-2.379,3.306,3.306,0,0,0-.91-2.374A3.27,3.27,0,0,0,7.8,4.3Z" transform="translate(0 0)" fill="#0e3f92" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>     <ellipse id="Elipse_3493" data-name="Elipse 3493" cx="1.926" cy="1.926" rx="1.926" ry="1.926" transform="translate(5.977 24.782)" fill="#0e3f92"/>     <ellipse id="Elipse_3494" data-name="Elipse 3494" cx="2.407" cy="2.407" rx="2.407" ry="2.407" transform="translate(31.011 43.075)" fill="#0e3f92"/>   </g> </svg>',
        welcomeHome: {
            incomeTaxDe: '15%',
            descriptionEn:
                'The commuting module gives your employees net benefits in terms of commuting. This includes all distances that are not covered by public transport on the way to work. This building block can be particularly attractive for commuters.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Distance allowance',
            additionalityReq: true,
            maxAmountDe:
                'von KM 1-20: 0,30 € ab KM 21: 0,38 €  pro Kilometer max. 4.500 € pro Jahr',
            incomeTaxEn: '15%',
            descriptionDe:
                'Der Arbeitsweg-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile in Bezug auf den Arbeitsweg. Hierzu zählen alle Entfernungen, die auf dem Weg zur Arbeit nicht mit öffentlichen Verkehrsmitteln zurücklegt werden. Besondern für Pendler kann dieser Baustein sehr reizvoll sein.',
            legalBasis:
                '§ 9 Abs. 1 S. 3 Nr. 4 EStG; § 40 Abs. 2 S. 2 Nr. 1 b) EStG;  R 40.2 Abs. 6 LStR',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Entfernungspauschale',
            maxAmountEn:
                'from KM 1-20: €0.30 from KM 21: €0.38 per kilometer max. €4,500 per year',
        },
    },
    {
        id: 'internet',
        status: 'ACTIVE',
        nameDe: 'Internet-Baustein',
        nameEn: 'Internet Benefit',
        descriptionDe:
            'Der Internet-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile bei den privaten Internetkosten.',
        descriptionEn:
            'The internet module gives your employees net benefits in terms of private internet costs.',
        icon: 'assets%2Ficons%2Fservice-internet.svg?alt=media&token=595c69c7-fcbe-4afb-851d-35ad3f3dac85',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="43.622" height="31.107"><path d="M.92 9.297l3.8 3.8a24.175 24.175 0 0134.186 0l3.8-3.8A29.639 29.639 0 0021.651.651 29.289 29.289 0 00.92 9.297zm15.194 15.194l5.7 5.7 5.7-5.7a8.047 8.047 0 00-11.4 0zm-7.6-7.6l3.8 3.8a13.434 13.434 0 0118.992 0l3.8-3.8a18.822 18.822 0 00-26.586.003z" fill="none" stroke="#5689a3" stroke-width="1.3"/></svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="49.289" height="34.844" viewBox="0 0 49.289 34.844">   <path id="ic_wifi_24px" d="M1,14.647l4.481,4.481a28.518,28.518,0,0,1,40.327,0l4.481-4.481a34.964,34.964,0,0,0-24.834-10.2A34.551,34.551,0,0,0,1,14.647ZM18.923,32.57l6.721,6.721,6.721-6.721A9.493,9.493,0,0,0,18.923,32.57ZM9.962,23.609l4.481,4.481a15.848,15.848,0,0,1,22.4,0l4.481-4.481A22.2,22.2,0,0,0,9.962,23.609Z" transform="translate(-1 -4.447)" fill="#0e3f92"/> </svg>',
        welcomeHome: {
            incomeTaxDe: 'pauschal 25%',
            descriptionEn:
                'With the Internet module, you take over the private Internet costs of your employees and can thus support home office activities.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Internet costs',
            additionalityReq: true,
            maxAmountDe: '50,00 € pro Monat 600,00 € pro Jahr',
            incomeTaxEn: 'flat rate 25%',
            descriptionDe:
                'Mit dem Internet-Baustein übernehmen Sie die privaten Internet-Kosten Ihrer Mitarbeiter und können so die Homeoffice Tätigkeit unterstützen. ',
            legalBasis: '§ 40 Abs. 2 S. 1 Nr. 5 Satz 2 EStG',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Kosten Internet',
            maxAmountEn: '€50.00 per month €600.00 per year',
        },
    },
    {
        id: 'job-ticket',
        status: 'ACTIVE',
        nameDe: 'Jobticket-Baustein',
        nameEn: 'Jobticket Benefit',
        descriptionDe:
            'Der Jobticket-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile bei Transportkosten durch den öffentlichen Nahverkehr.',
        descriptionEn:
            'The job ticket module enables your employees to benefit from net transport cost benefits using local public transport.',
        icon: 'assets%2Ficons%2Fservice-job-ticket.svg?alt=media&token=0c2f8df9-3aea-43e8-bb1f-824d5a460495',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="51.098" height="51.099"><g data-name="Group 26634"><path data-name="Subtraction 160" d="M44.827 26.358L21.004 50.18.917 30.095 24.74 6.27l.676.676a.336.336 0 00.475-.474l-.676-.676L30.088.923l7.539 7.538-.013.013a3.583 3.583 0 005.05 5.05l.013-.012 7.495 7.495L45.3 25.88l-.681-.681a.338.338 0 00-.477.477l.68.68zm-3.57-4.052a.331.331 0 00-.015.467l1.74 1.74a.339.339 0 00.47-.012.335.335 0 00.008-.466l-1.74-1.74a.328.328 0 00-.463.01zM38.29 19.34a.337.337 0 00-.011.47l1.74 1.74a.338.338 0 00.477-.477l-1.74-1.74a.332.332 0 00-.466.007zM18.95 35.505a1.5 1.5 0 102.12 2.121L33.8 24.898a1.5 1.5 0 00-2.12-2.121zM35.34 16.39a.337.337 0 00-.011.47l1.74 1.74a.338.338 0 00.477-.477l-1.74-1.74a.33.33 0 00-.466.007zm-2.93-2.93a.336.336 0 00-.014.467l1.743 1.743a.336.336 0 00.467-.014.332.332 0 00.01-.463l-1.743-1.743a.332.332 0 00-.462.011zM13.998 30.554a1.5 1.5 0 002.122 2.121l12.728-12.728a1.5 1.5 0 00-2.122-2.121zM29.461 10.51a.336.336 0 00-.014.466l1.743 1.743a.338.338 0 00.477-.477L29.924 10.5a.332.332 0 00-.462.011zM26.64 7.689a.342.342 0 00-.011.47l1.74 1.74a.338.338 0 00.477-.478l-1.74-1.74a.334.334 0 00-.466.008z" fill="none" stroke="#5689a3" stroke-miterlimit="10" stroke-width="1.3"/></g></svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="44.264" height="44.264" viewBox="0 0 44.264 44.264">   <g id="Grupo_35999" data-name="Grupo 35999" transform="translate(0.707 26.082) rotate(-45)">     <path id="Subtração_160" data-name="Subtração 160" d="M29.307,24.712H0V0H29.308V.833a.293.293,0,0,0,.586,0V0h5.992V9.274H35.87a2.993,2.993,0,0,0-2.856,3.107,2.993,2.993,0,0,0,2.856,3.107h.015V24.71H29.892v-.837a.293.293,0,0,0-.585,0v.837Zm.292-4.689a.287.287,0,0,0-.292.281v2.141a.293.293,0,0,0,.585,0V20.3A.287.287,0,0,0,29.6,20.023Zm0-3.646a.287.287,0,0,0-.292.281V18.8a.293.293,0,0,0,.585,0v-2.14A.287.287,0,0,0,29.6,16.377ZM7.761,14.421a1.3,1.3,0,1,0,0,2.609H23.418a1.3,1.3,0,1,0,0-2.609ZM29.6,12.748a.287.287,0,0,0-.292.281v2.14a.293.293,0,0,0,.585,0v-2.14A.287.287,0,0,0,29.6,12.748Zm0-3.6a.288.288,0,0,0-.292.28v2.142a.293.293,0,0,0,.585,0V9.424A.288.288,0,0,0,29.6,9.144ZM7.762,8.333a1.3,1.3,0,1,0,0,2.609H23.419a1.3,1.3,0,1,0,0-2.609ZM29.6,5.515a.287.287,0,0,0-.291.279V7.935a.293.293,0,0,0,.585,0V5.794a.287.287,0,0,0-.293-.279Zm0-3.472a.289.289,0,0,0-.292.281V4.465a.293.293,0,0,0,.585,0V2.324A.29.29,0,0,0,29.6,2.043Z" transform="translate(0 0)" fill="#0e3f92" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>   </g> </svg>',
        welcomeHome: {
            incomeTaxDe: 'frei',
            descriptionEn:
                'With the job ticket module, you can financially support your employees with their travel costs using public transport between home and work. The car is left where it is and the environment breathes a sigh of relief.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Jobticket',
            additionalityReq: true,
            maxAmountDe: 'unbegrenzt',
            incomeTaxEn: 'free',
            descriptionDe:
                'Mit dem Jobticket-Baustein können Sie Ihre Mitarbeiter bei den Fahrtkosten durch öffentliche Verkehrsmittel zwischen Wohnung und Arbeitsplatz finanziell unterstützen. Das Auto wird stehen gelassen, und die Umwelt atmet auf.',
            legalBasis: '§ 3 Nr. 15 EStG',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Jobticket',
            maxAmountEn: 'unlimited',
        },
    },
];
export const SERVICES_SECTION2 = [
    {
        id: 'mobile',
        status: 'ACTIVE',
        nameDe: 'Handytarif-Baustein',
        nameEn: 'Mobile tariff Benefit',
        descriptionDe:
            'Mit dem Handytarif-Baustein ermöglichen Sie Ihren Arbeitnehmern Nettovorteile bei deren privaten Handyverbindungskosten. Hierbei handelt es sich um die Bezuschussung des privaten Handyvertrages Ihres Mitarbeiters.',
        descriptionEn:
            "With the mobile tariff component, you provide net benefits to your employees for their private mobile connection costs. This involves subsidizing your employee's private mobile contract.",
        icon: 'assets%2Ficons%2Fservice-mobile.svg?alt=media&token=8445fd3f-4b53-4bda-bdd2-677b799c7e50',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="38.415" height="40.218"><g data-name="Gruppe 24326"><path data-name="Differenzmenge 133" d="M37.766 22.974l-16.361.061V.713L37.766.652z" fill="none" stroke="#5689a3" stroke-width="1.3"/><g data-name="Gruppe 24100"><path data-name="Rechteck 3202" fill="#5689a3" d="M24.79 13.275h9.66v1.26h-9.66z"/><path data-name="Rechteck 3202-2" fill="#5689a3" d="M24.79 9.916h9.66v1.26h-9.66z"/><path data-name="Rechteck 3202-3" fill="#5689a3" d="M24.79 6.555h9.66v1.26h-9.66z"/><path data-name="Rechteck 3203" fill="#5689a3" d="M24.79 16.636h9.66v1.26h-9.66z"/><path data-name="ic phone android 24px" d="M16.935 5.997H5.091a4.5 4.5 0 00-4.44 4.568h0v24.423a4.505 4.505 0 004.43 4.577h11.854a4.5 4.5 0 004.441-4.566h0V10.572a4.5 4.5 0 00-4.43-4.577h-.011zm-2.959 30.517H8.058v-1.526h5.922zm4.81-3.807H3.243V10.572h15.543z" fill="rgba(0,0,0,0)" stroke="#5689a3" stroke-width="1.3"/></g></g></svg>',
        iconSvgFilled:
            '<svg id="Grupo_36031" data-name="Grupo 36031" xmlns="http://www.w3.org/2000/svg" width="40.824" height="44.64" viewBox="0 0 40.824 44.64">   <path id="Caminho_39704" data-name="Caminho 39704" d="M2986.27-7146.126v-28.21h-20.615v7.725a4.99,4.99,0,0,0-2.056-.487h-13.2a5.019,5.019,0,0,0-4.949,5.089v27.213a5.019,5.019,0,0,0,4.938,5.1h13.2a5.021,5.021,0,0,0,4.949-5.091v-11.338Zm-17.6-25.189h14.979v22.167h-14.979Zm-14.973,38.218v-1.7h6.6v1.7Zm11.958-4.242h-17.318V-7162h17.318Z" transform="translate(-2945.445 7174.337)" fill="#0e3f92"/>   <rect id="Rechteck_3202" data-name="Rechteck 3202" width="10.481" height="1.367" transform="translate(25.583 15.738)" fill="#0e3f92"/>   <rect id="Rechteck_3202-2" data-name="Rechteck 3202-2" width="10.481" height="1.367" transform="translate(25.583 12.093)" fill="#0e3f92"/>   <rect id="Rechteck_3202-3" data-name="Rechteck 3202-3" width="10.481" height="1.367" transform="translate(25.583 8.447)" fill="#0e3f92"/>   <rect id="Rechteck_3203" data-name="Rechteck 3203" width="10.481" height="1.367" transform="translate(25.583 19.384)" fill="#0e3f92"/> </svg>',
        welcomeHome: {
            incomeTaxDe: 'frei',
            descriptionEn:
                'The mobile phone is nowadays an essential component for private as well as professional communication. Take over the private mobile connection costs of your employees with the mobile phone tariff module.',
            socialInsuranceDe: 'In Zusätzlichkeit sozialversicherungs&shy;frei',
            aliasEn: 'Mobile phone contract costs',
            additionalityReq: false,
            maxAmountDe: '20 % der Rechnung,  max. 20 €',
            incomeTaxEn: 'free',
            descriptionDe:
                'Das Handy ist heutzutage ein wesentlicher Bestandteil für die private als auch berufliche Kommunikation. Übernehmen Sie mit dem Handytarif-Baustein die privaten Handyverbindungskosten Ihrer Mitarbeiter.',
            legalBasis: '§ 3 Nr. 45 EStG',
            socialInsuranceEn: 'In additionality social security free',
            aliasDe: 'Handyvertragskosten',
            maxAmountEn: '20% of the bill, up to €20',
        },
    },
    {
        id: 'recreational-activities',
        status: 'ACTIVE',
        nameDe: 'Urlaubs-Baustein',
        nameEn: 'Recreational Activities Benefit',
        descriptionDe:
            'Der Urlaubs-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile bei Ausgaben für Erholungsmaßnahmen, wie z.B.: Städtereisen, Urlaub, Wellnessbehandlungen, uvm.',
        descriptionEn:
            'The vacation component allows your employees to enjoy net benefits for expenses related to relaxation activities, such as city trips, vacations, wellness treatments, and more.',
        icon: 'assets%2Ficons%2Fservice-recreation.svg?alt=media&token=e29d9c52-4391-4890-b5c0-9d474bc31ca5',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="36.712" height="37.101"><path d="M20.427 23.466l2.793-2.823 12.578 12.718-2.787 2.817zm8.385-11.31l5.586-5.645a19.616 19.616 0 00-27.93-.04 21.653 21.653 0 0122.343 5.685zM6.409 6.53a20.124 20.124 0 00.04 28.226l5.586-5.645A22.206 22.206 0 016.409 6.53zm.04-.04l-.02.02c-.742 5.941 2.285 13.58 8.4 19.778l11.191-11.31a31.785 31.785 0 00-9.9-6.852A18.833 18.833 0 006.449 6.49z" fill="none" stroke="#5689a3" stroke-width="1.3"/></svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="37.874" height="38.284" viewBox="0 0 37.874 38.284">   <path id="ic_beach_access_24px" d="M24.312,27.587l3.01-3.042,13.554,13.7-3,3.035ZM33.347,15.4l6.019-6.083a21.137,21.137,0,0,0-30.1-.043A23.332,23.332,0,0,1,33.347,15.4ZM9.207,9.337a21.685,21.685,0,0,0,.042,30.416l6.019-6.083A23.929,23.929,0,0,1,9.207,9.337Zm.042-.043-.021.021c-.8,6.4,2.462,14.634,9.05,21.313L30.338,18.441a34.25,34.25,0,0,0-10.665-7.384A20.294,20.294,0,0,0,9.249,9.295Z" transform="translate(-3.001 -3.001)" fill="#0e3f92"/> </svg>',
        welcomeHome: {
            incomeTaxDe: 'pauschal 25%',
            descriptionEn:
                'For a good work-life balance, a relaxing holiday should not be missing! With the vacation module, your employees benefit from your financial support for spending on recreational measures (vacation, city trips, wellness treatments, travel and flight costs)',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Recreation allowance',
            additionalityReq: false,
            maxAmountDe:
                '156,00 € pro Jahr + 104,00 € für  Lebenspartner:in + 52,00 € pro Kind',
            incomeTaxEn: 'flat rate 25%',
            descriptionDe:
                'Für eine ausgeglichene Work-Life-Balance, darf ein erholsamer Urlaub nicht fehlen! Mit dem Urlaubs-Baustein profitieren Ihre Mitarbeiter von Ihrer finanziellen Unterstützung bei Ausgaben für Erholungsmaßnahmen (Urlaub, Städtereisen, Wellnessbehandlungen, Fahrt- und Flugkosten)',
            legalBasis:
                '§ 40 Abs. 2 S. 1 Nr. 3 EStG;  R 40.2 Abs. 1 Nr. 3 LStR',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Erholungsbeihilfe',
            maxAmountEn:
                '€156.00 per year + €104.00 for Life partner: in + €52.00 per child',
        },
    },
    {
        id: 'restaurant',
        status: 'ACTIVE',
        nameDe: 'Essens-Baustein',
        nameEn: 'Meal Allowance Benefit',
        descriptionDe:
            'Der Essens-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile bei Ausgaben für Mahlzeiten, während der Arbeitszeit oder unmittelbar danach.',
        descriptionEn:
            'The meal module gives your employees net benefits when spending on meals, during or immediately after work',
        icon: 'assets%2Ficons%2Fservice-restaurant.svg?alt=media&token=7981558b-2591-4d67-a990-a4a0051632ba',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="31.682" height="36.023" viewBox="0 0 31.682 36.023">   <path id="ic_restaurant_24px" d="M16.315,14.084s-3.171.022-3.191,0S13.127,2,13.127,2H9.752V14.153H6.376V2H3V14.153a6.839,6.839,0,0,0,6.33,6.893V36.723h4.22V21.046a6.839,6.839,0,0,0,6.33-6.893V2H16.5Zm8.627-5.139V22.834h4.22V36.723h4.22V2C28.723,2,24.942,5.889,24.942,8.945Z" transform="translate(-2.35 -1.35)" fill="none" stroke="#5689a3" stroke-width="1.3"/> </svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="32.293" height="36.907" viewBox="0 0 32.293 36.907">   <path id="ic_restaurant_24px" d="M17.153,14.844s-3.37.023-3.392,0S13.764,2,13.764,2H10.176V14.917H6.588V2H3V14.917a7.27,7.27,0,0,0,6.728,7.326V38.907h4.485V22.243a7.27,7.27,0,0,0,6.728-7.326V2H17.352Zm9.17-5.462V24.144h4.485V38.907h4.485V2C30.341,2,26.323,6.134,26.323,9.381Z" transform="translate(-3 -2)" fill="#0e3f92"/> </svg>',
        welcomeHome: {
            incomeTaxDe: '4,13 € pauschal  25% versteuert  + 3,10 € steuerfrei',
            descriptionEn:
                'Take care of the physical well-being of your employees! With the meal module, your employees’ meals can be subsidized during working hours or immediately afterwards.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Restaurant vouchers',
            additionalityReq: false,
            maxAmountDe: '7,23 € pro Tag  (Sachbezugswert 4,13 € zzgl. 3,10 €)',
            incomeTaxEn: '€4.13 flat rate 25% taxed + €3.10 tax-free',
            descriptionDe:
                'Sorgen Sie für das leibliche Wohl Ihrer Mitarbeiter! Mit dem Essens-Baustein können die Mahlzeiten Ihrer Mitarbeiter, während der Arbeitszeit oder unmittelbar danach bezuschusst werden.',
            legalBasis:
                '§ 8 Abs. 2 EStG; § 40 Abs. 2 S. 1 Nr. 1 EStG; R 8.1 Abs. 7  Nr. 4 LStR; BMF-Schreiben v. 18.01.2019, BStBl 2019 I S. 66',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Restaurantgutscheine',
            maxAmountEn: '€7.23 per day (Reference value €4.13 plus €3.10)',
        },
    },
    {
        id: 'retirement',
        status: 'ACTIVE',
        nameDe: 'Renten-Baustein',
        nameEn: 'Retirement',
        descriptionDe:
            "Der Renten-Baustein ist für Ihre Mitarbeiter eine attraktive Möglichkeit für's Alter vorzusorgen. Hierbei handelt es sich um eine betriebliche Altersvorsorge, d.h. dass pro 1€ der vom Netto aufgewendet wird, mehr als das Doppelte in die Verbesserung der Rente fließt.",
        descriptionEn:
            'The pension component is an attractive way for your employees to save for their retirement. This involves a company pension plan, meaning that for every €1 contributed from the net income, more than twice that amount goes into improving the pension.',
        icon: 'assets%2Ficons%2Fservice-retirement.svg?alt=media&token=08e863f7-c512-4f3a-8679-5d56d8e0eb26',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="46.766" height="45.002" viewBox="0 0 46.766 45.002">   <g id="Group_26643" data-name="Group 26643" transform="translate(0 1)">     <g id="Group_26642" data-name="Group 26642">       <g id="Grupo_2" data-name="Grupo 2">         <path id="Pfad_39687" data-name="Pfad 39687" d="M43.9,13.253c1.886,2.952-.113,3.425-1.734,3.826a17.909,17.909,0,0,0-10.159-8.5c-.043,0-1.047,2.512-2.094,3.262-1.984,1.328-2.477,1.625-4.578,1.625a6.937,6.937,0,0,1-6.828-5.437,15.606,15.606,0,0,0-1.638.551C15.387,7.677,7.814,3.2,8.1,6.324a18.492,18.492,0,0,0,1.876,6.26,15.917,15.917,0,0,0-4.155,5.823H1.867A1.221,1.221,0,0,0,.65,19.625v8.2a1.22,1.22,0,0,0,1.217,1.217H5.758a1.3,1.3,0,0,0,.168-.014,16.149,16.149,0,0,0,4.52,5.98v7.125a1.222,1.222,0,0,0,1.217,1.218h5.306a1.223,1.223,0,0,0,1.217-1.218V39a23.148,23.148,0,0,0,6.117.816,22.965,22.965,0,0,0,6.791-1.012v3.326a1.222,1.222,0,0,0,1.217,1.218h5.31a1.223,1.223,0,0,0,1.217-1.218V34.413a14.756,14.756,0,0,0,4.968-10.819,13.69,13.69,0,0,0-.515-3.716,7.9,7.9,0,0,0,1.229-.92c3.853-3.453-.618-5.7-.618-5.7ZM13.714,22a2.185,2.185,0,0,1-2.187-2.158v-.013A2.157,2.157,0,0,1,13.7,17.685h.009a2.16,2.16,0,0,1,2.142,2.178h0a2.411,2.411,0,0,1-.6,1.446A2.025,2.025,0,0,1,13.714,22Z" fill="none" stroke="#5689a3" stroke-width="1.3"/>         <g id="Gruppe_26607" data-name="Gruppe 26607" transform="translate(-0.031 -13)">           <path id="Caminho_1" data-name="Caminho 1" d="M14.6.406" transform="translate(17.98 21.5)" fill="none" stroke="#fff" stroke-width="1.5"/>           <g id="Grupo_1" data-name="Grupo 1" transform="translate(-0.288 12)">             <g id="Gruppe_26641" data-name="Gruppe 26641">               <path id="Pfad_39689" data-name="Pfad 39689" d="M28.758,9.941a4.436,4.436,0,0,1-1.345.92,3.8,3.8,0,0,1-1.555.341,3.953,3.953,0,0,1-1.655-.347,3.743,3.743,0,0,1-1.3-.967,3.481,3.481,0,0,1-.746-1.419H21.106v-.65h.935q-.018-.183-.021-.368a1.787,1.787,0,0,1,.01-.231H21.1V6.57h1.019a3.513,3.513,0,0,1,.741-1.46,3.76,3.76,0,0,1,1.329-1,4.1,4.1,0,0,1,3.257-.048,3.889,3.889,0,0,1,1.292.861l-.819,1.029a3.036,3.036,0,0,0-.93-.7A2.459,2.459,0,0,0,24.5,5.43a2.3,2.3,0,0,0-.882,1.141H26.3v.65H23.475a1.5,1.5,0,0,0-.01.211,2.2,2.2,0,0,0,.031.389h2.8v.65H23.68a2.339,2.339,0,0,0,.9,1.024,2.455,2.455,0,0,0,1.35.384,2.643,2.643,0,0,0,1.051-.226,3.074,3.074,0,0,0,.946-.636Z" fill="#5689a3"/>             </g>           </g>           <g id="Ellipse_3593" data-name="Ellipse 3593" transform="translate(-0.288 12)">             <g id="Gruppe_26639" data-name="Gruppe 26639">               <ellipse id="Ellipse_3495" data-name="Ellipse 3495" cx="7" cy="7.5" rx="7" ry="7.5" transform="translate(18.657 0.121)" fill="none"/>             </g>             <g id="Gruppe_26640" data-name="Gruppe 26640">               <path id="Pfad_39688" data-name="Pfad 39688" d="M25.657,15.24a7.667,7.667,0,0,1-7.7-7.62,7.695,7.695,0,0,1,15.389,0,7.666,7.666,0,0,1-7.694,7.62Zm0-13.761A6.185,6.185,0,0,0,19.441,7.62a6.215,6.215,0,0,0,12.43,0,6.185,6.185,0,0,0-6.214-6.139Z" fill="#5689a3"/>             </g>           </g>         </g>         <path id="Rechteck_6288" data-name="Rechteck 6288" d="M19.453,13.567H31.8v6H19.453Z" fill="none"/>       </g>     </g>   </g> </svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="43.984" height="41.295" viewBox="0 0 43.984 41.295">   <g id="Grupo_36011" data-name="Grupo 36011" transform="translate(0 0)">     <path id="Caminho_39683" data-name="Caminho 39683" d="M2116.135-7991.291c1.826,2.857-.109,3.317-1.678,3.7a17.539,17.539,0,0,0-9.174-7.883c0,.016-.006.03-.009.046a6.83,6.83,0,0,0,.1-1.158,6.917,6.917,0,0,0-6.943-6.876,6.917,6.917,0,0,0-6.943,6.876c0,.1,0,.208.008.312h0q-.771.2-1.528.458c-1.436-.878-8.768-5.211-8.493-2.187a17.93,17.93,0,0,0,1.816,6.06,15.4,15.4,0,0,0-4.022,5.636l-.06,0h-3.767a1.182,1.182,0,0,0-1.178,1.178v7.935a1.182,1.182,0,0,0,1.178,1.179h3.767a1.14,1.14,0,0,0,.163-.015,15.65,15.65,0,0,0,4.375,5.79v6.9a1.183,1.183,0,0,0,1.179,1.179h5.136a1.182,1.182,0,0,0,1.178-1.179v-3.029a22.356,22.356,0,0,0,5.922.79,22.231,22.231,0,0,0,6.573-.98v3.22a1.182,1.182,0,0,0,1.178,1.179h5.136a1.182,1.182,0,0,0,1.179-1.179v-7.475a14.279,14.279,0,0,0,4.81-10.472,13.263,13.263,0,0,0-.5-3.6,7.525,7.525,0,0,0,1.19-.89C2120.466-7989.109,2116.135-7991.291,2116.135-7991.291Zm-29.223,8.465a2.116,2.116,0,0,1-2.117-2.089v-.011a2.089,2.089,0,0,1,2.1-2.073h.008a2.091,2.091,0,0,1,2.074,2.109A2.128,2.128,0,0,1,2086.912-7982.826Zm6.854-8.664h-.7a.9.9,0,0,1-.9-.9.893.893,0,0,1,.3-.668A8.412,8.412,0,0,0,2093.765-7991.49Zm6.755.048h-4.179a5.55,5.55,0,0,1-3.519-5.14,5.581,5.581,0,0,1,5.608-5.542,5.581,5.581,0,0,1,5.608,5.542A5.55,5.55,0,0,1,2100.521-7991.441Zm3.213-.048h-.637a12.874,12.874,0,0,0,1.272-1.535l0,0a.9.9,0,0,1,.26.632A.9.9,0,0,1,2103.734-7991.49Z" transform="translate(-2074.265 8003.458)" fill="#0e3f92"/>     <path id="Caminho_39684" data-name="Caminho 39684" d="M2229.829-7972.833a2.378,2.378,0,0,1-.948.2,2.217,2.217,0,0,1-1.218-.346,2.12,2.12,0,0,1-.811-.924h2.361v-.588h-2.531a2.146,2.146,0,0,1-.029-.351,1.444,1.444,0,0,1,.01-.189h2.55v-.588H2226.8a2.065,2.065,0,0,1,.8-1.029,2.212,2.212,0,0,1,1.289-.393,2.192,2.192,0,0,1,.962.231,2.744,2.744,0,0,1,.839.63l.739-.928a3.5,3.5,0,0,0-1.166-.778,3.613,3.613,0,0,0-1.393-.285,3.64,3.64,0,0,0-1.545.329,3.4,3.4,0,0,0-1.2.9,3.175,3.175,0,0,0-.668,1.318h-.919v.588h.834a1.52,1.52,0,0,0-.01.208c0,.082.006.193.019.332h-.844v.588h.948a3.158,3.158,0,0,0,.673,1.279,3.375,3.375,0,0,0,1.171.874,3.578,3.578,0,0,0,1.493.312,3.42,3.42,0,0,0,1.4-.309,3.975,3.975,0,0,0,1.213-.829l-.749-.834A2.794,2.794,0,0,1,2229.829-7972.833Z" transform="translate(-2204.467 7981.543)" fill="#0e3f92"/>   </g> </svg>',
        welcomeHome: {
            incomeTaxDe: 'frei',
            descriptionEn:
                'The pension module is an attractive way to make provisions for old age. For every €1 that your employees spend from the net, more than twice that goes towards improving their pension.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            additionalityReq: false,
            maxAmountDe: '3.624,00 € pro Jahr',
            incomeTaxEn: 'free',
            legalBasis: '§ 3 Nr. 63 EStG',
            descriptionDe:
                'Der Renten-Baustein ist eine attraktive Möglichkeit für’s Alter vorzusorgen. Pro 1 € den Ihre Mitarbeiter vom Netto aufwenden, fließt mehr als das Doppelte in die Verbesserung der Rente.',
            socialInsuranceEn: 'social insurance free',
            maxAmountEn: '€3,504.00 per year',
        },
    },
];
export const SERVICES_SECTION3 = [
    {
        id: 'birthday',
        status: 'ACTIVE',
        nameDe: 'Geburtstags-Baustein',
        nameEn: 'Birthday Benefit',
        descriptionDe:
            'Mit dem Geburtstags-Baustein machen Sie Ihren Mitarbeitern anlässlich des Geburtstages mit einem Gutschein im Wert von bis zu 60€ eine Freude.',
        descriptionEn:
            'With the birthday module, you can make your employees happy on the occasion of their birthday with a voucher worth up to €60.',
        icon: 'assets%2Ficons%2Fservice-birthday.svg?alt=media&token=5a41f3e2-5a87-42c7-bd28-199648fa0e4c',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="38.93" height="37.3"><g data-name="Group 26633" fill="none" stroke="#5689a3" stroke-width="1.3"><path data-name="Path 37219" d="M34.516 9.221h-1.469a4.876 4.876 0 001.469-3.429A5.439 5.439 0 0028.874.645c-2.991 0-5.329 1.728-7.174 3.429h-4.468c-1.845-1.7-4.178-3.429-7.173-3.429a5.439 5.439 0 00-5.644 5.143 4.872 4.872 0 001.47 3.428h-1.47a3.613 3.613 0 00-3.763 3.429v3.429h16.953V7.906h3.724v8.168h16.953v-3.429a3.614 3.614 0 00-3.766-3.424zM10.057 7.508a1.722 1.722 0 110-3.429c1.207 0 3.4 1.313 5.056 2.893.279.268.219.275.471.536zm18.815 0h-5.526c.25-.261.191-.268.47-.536 1.653-1.581 3.843-2.893 5.056-2.893a1.722 1.722 0 110 3.429z"/><g data-name="Group 24301"><path data-name="Path 37220" d="M17.603 17.793H2.451v15.428a3.614 3.614 0 003.763 3.429h11.389z"/><path data-name="Path 37221" d="M23.147 17.793h-1.82v18.852h11.227a3.614 3.614 0 003.763-3.429V17.793z"/></g></g></svg>',
        iconSvgFilled:
            '<svg id="Grupo_36303" data-name="Grupo 36303" xmlns="http://www.w3.org/2000/svg" width="34.074" height="32.598" viewBox="0 0 34.074 32.598">   <path id="Caminho_37219" data-name="Caminho 37219" d="M372.041,427.566h-1.33a4.415,4.415,0,0,0,1.33-3.1,4.924,4.924,0,0,0-5.111-4.656c-2.708,0-4.825,1.565-6.5,3.1h-4.046c-1.671-1.54-3.783-3.1-6.5-3.1a4.925,4.925,0,0,0-5.111,4.657,4.412,4.412,0,0,0,1.331,3.1h-1.331a3.271,3.271,0,0,0-3.407,3.1v3.105h15.351v-7.4H360.1v7.4H375.45v-3.105A3.273,3.273,0,0,0,372.041,427.566Zm-22.147-1.551a1.559,1.559,0,1,1,0-3.1c1.093,0,3.08,1.189,4.578,2.62.253.243.2.249.426.485Zm17.037,0h-5c.226-.236.173-.243.426-.485,1.5-1.432,3.48-2.62,4.578-2.62a1.559,1.559,0,1,1,0,3.1Z" transform="translate(-341.376 -419.805)" fill="#0e3f92"/>   <g id="Grupo_24301" data-name="Grupo 24301" transform="translate(1.631 15.523)">     <path id="Caminho_37220" data-name="Caminho 37220" d="M356.9,436.948h-13.72v13.97a3.272,3.272,0,0,0,3.407,3.1H356.9Z" transform="translate(-343.177 -436.948)" fill="#0e3f92"/>     <path id="Caminho_37221" data-name="Caminho 37221" d="M363.7,436.948h-1.648v17.075h10.166a3.273,3.273,0,0,0,3.407-3.1v-13.97Z" transform="translate(-344.961 -436.948)" fill="#0e3f92"/>   </g> </svg>',
        welcomeHome: {
            incomeTaxDe: 'frei',
            descriptionEn:
                'Valuable employees are a treasure! Use the birthday module and make your employees happy with a voucher worth up to €60 for their birthday.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Attentions',
            additionalityReq: true,
            maxAmountDe: '60,00 €  pro Anlass',
            incomeTaxEn: 'free',
            legalBasis: 'R 19.6 Abs. 1 LStR',
            descriptionDe:
                'Wertvolle Mitarbeiter sind ein Schatz! Nutzen Sie den Geburtstags-Baustein und bereiten Sie Ihren Mitarbeitern mit einem Gutschein im Wert von bis zu 60 € zum Geburtstag eine Freude.',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Aufmerksamkeiten',
            maxAmountEn: '€60.00 per occasion',
        },
    },
    {
        id: 'coupon',
        status: 'ACTIVE',
        nameDe: 'Gutschein-Baustein',
        nameEn: 'Coupon Benefit',
        descriptionDe:
            'Der Gutschein-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile bei Einkäufen jeglicher Art. Ihre Mitarbeiter können jeden Monat erneut wählen, von welcher Partner-Firma ein Gutschein erhalten werden möchte. Partnerfirmen sind z.B.: Saturn, IKEA, H&M und viele mehr.',
        descriptionEn:
            'The coupon module gives your employees net advantages for purchases of any kind. Your employees can choose each month from which partner company they would like to receive a voucher. Partner companies are e.g.: Saturn, IKEA, H&M and many more.',
        icon: 'assets%2Ficons%2Fservice-purchases-discounts.svg?alt=media&token=c91ba76c-7d31-4505-a4b7-df076eb99060',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="38.01" height="31.093"><path d="M33.809 6.835h-4.034a4.153 4.153 0 00.333-1.584c0-2.629-2.48-4.751-5.551-4.751a5.83 5.83 0 00-4.627 2.138L19.005 3.7l-.925-1.078A5.867 5.867 0 0013.454.5C10.382.5 7.9 2.622 7.9 5.251a4.153 4.153 0 00.333 1.584H4.2A3.436 3.436 0 00.519 10L.5 27.425a3.454 3.454 0 003.7 3.168h29.609a3.454 3.454 0 003.7-3.168V10a3.454 3.454 0 00-3.7-3.165zm-9.252-3.167a1.738 1.738 0 011.851 1.584 1.873 1.873 0 01-3.7 0 1.738 1.738 0 011.849-1.584zm-11.1 0A1.738 1.738 0 0115.3 5.251a1.738 1.738 0 01-1.851 1.584A1.738 1.738 0 0111.6 5.251a1.738 1.738 0 011.854-1.583zm21.06 23.757H3.5v-3.168h31.014zm0-7.919H3.5V10h10.1l-3.849 4.482 3 1.853 4.4-5.132 1.851-2.154 1.851 2.154 4.4 5.132 3-1.853L24.409 10h10.105z" fill="none" stroke-width="1.3" stroke="#5689a3"/></svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="40.908" height="33.262" viewBox="0 0 40.908 33.262">   <path id="ic_redeem_24px" d="M38.817,9H34.358a4.591,4.591,0,0,0,.368-1.751C34.726,4.346,31.986,2,28.59,2a6.444,6.444,0,0,0-5.114,2.363L22.454,5.536l-1.023-1.19A6.484,6.484,0,0,0,16.318,2c-3.4,0-6.136,2.346-6.136,5.252A4.591,4.591,0,0,0,10.55,9H6.091a3.8,3.8,0,0,0-4.07,3.5L2,31.761a3.817,3.817,0,0,0,4.091,3.5H38.817a3.817,3.817,0,0,0,4.091-3.5V12.5A3.817,3.817,0,0,0,38.817,9ZM28.59,5.5a1.921,1.921,0,0,1,2.045,1.751,2.07,2.07,0,0,1-4.091,0A1.921,1.921,0,0,1,28.59,5.5Zm-12.272,0a1.921,1.921,0,0,1,2.045,1.751A1.921,1.921,0,0,1,16.318,9a1.921,1.921,0,0,1-2.045-1.751A1.921,1.921,0,0,1,16.318,5.5ZM39.6,31.761H5.312v-3.5H39.6Zm0-8.753H5.312V12.5h11.17l-4.254,4.954,3.314,2.048,4.868-5.672,2.045-2.381L24.5,13.834l4.868,5.672,3.314-2.048L28.427,12.5H39.6Z" transform="translate(-2 -2)" fill="#0e3f92"/> </svg>',
        welcomeHome: {
            incomeTaxDe: 'frei',
            descriptionEn:
                "The voucher module is one of the most popular benefits. Whether it's a new television or for the next drugstore purchase. Your employees can flexibly choose each month from which of our numerous partner companies (Saturn, IKEA, H&M, etc.) you would like to receive a voucher.",
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Vouchers up to €50',
            additionalityReq: true,
            maxAmountDe: '50,00 € pro Monat',
            incomeTaxEn: 'free',
            legalBasis: '§ 8 Abs. 2  EStG',
            descriptionDe:
                'Der Gutschein-Baustein ist einer der beliebtesten Benefits. Egal ob ein neuer Fernseher oder für den nächsten Drogerie-Einkauf. Ihre Mitarbeiter können jeden Monat flexibel wählen, von welcher unserer zahlreichen Partner-Firmen (Saturn, IKEA, H&M, etc.) sie einen Gutschein erhalten möchten.',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Gutscheine bis zu 50,- €',
            maxAmountEn: '€50.00 per month',
        },
    },
    {
        id: 'employee-discount',
        status: 'ACTIVE',
        nameDe: 'Mitarbeiterrabatt-Baustein',
        nameEn: 'Employee discount Benefit',
        descriptionDe:
            'Der Mitarbeiterrabatt-Baustein ermöglicht Ihren Mitarbeitern Nettovorteile beim Bezug von Waren oder Dienstleistungen, die das Unternehmen anbietet.',
        descriptionEn:
            'The employee discount module enables your employees to obtain net benefits when purchasing goods or services that the company offers.',
        icon: 'assets%2Ficons%2Fservice-employee-discount.svg?alt=media&token=b0e7c77a-099c-46b6-aaed-2181bfc3c86d',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="41.619" height="41.619"><g data-name="Group 26631"><path data-name="ic brightness auto 24px" d="M34.881 14.988V6.74h-8.248L20.812.919 14.991 6.74H6.743v8.248L.922 20.809l5.821 5.821v8.244h8.248l5.821 5.821 5.821-5.821h8.248v-8.248l5.821-5.821z" fill="none" stroke="#5689a3" stroke-width="1.3"/><g><g data-name="Group 24306"><path data-name="Path 37222" d="M11.733 18.028c0-2.576 1.619-4.13 3.811-4.13 2.214 0 3.832 1.554 3.832 4.13 0 2.6-1.619 4.13-3.832 4.13-2.196-.001-3.811-1.532-3.811-4.13zm12.625-3.939h3.065l-10.176 14.9h-3.065zm-7.557 3.939c0-1.512-.532-2.107-1.257-2.107-.681 0-1.256.595-1.256 2.107s.575 2.107 1.256 2.107c.721 0 1.253-.596 1.253-2.107zm5.45 7.025c0-2.575 1.6-4.13 3.81-4.13s3.832 1.555 3.832 4.13c0 2.6-1.618 4.13-3.832 4.13s-3.814-1.533-3.814-4.126zm5.066 0c0-1.511-.553-2.108-1.256-2.108s-1.256.6-1.256 2.108.553 2.107 1.256 2.107 1.251-.595 1.251-2.103z" fill="none" stroke="#5689a3" stroke-width="1.3"/></g></g></g></svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="44.947" height="44.593" viewBox="0 0 44.947 44.593">   <path id="Exclusão_3" data-name="Exclusão 3" d="M19818.4,4299.547h0l-6.369-6.373H19803v-9.022l-6.367-6.373,6.367-6.369v-9.027h9.027l6.369-6.368,6.373,6.368h9.021v9.027l6.375,6.369-6.375,6.373v9.022h-9.021l-6.373,6.373Zm5.746-21.645c-2.5,0-4.174,1.817-4.174,4.521,0,2.747,1.639,4.521,4.174,4.521s4.191-1.774,4.191-4.521C19828.336,4279.72,19826.652,4277.9,19824.145,4277.9Zm-1.867-7.474-11.135,16.307h3.357l11.133-16.307Zm-9.641-.209c-2.5,0-4.172,1.815-4.172,4.516,0,2.747,1.637,4.521,4.172,4.521s4.193-1.774,4.193-4.521C19816.83,4272.035,19815.145,4270.22,19812.637,4270.22Zm11.508,14.509c-.514,0-1.375-.3-1.375-2.305s.861-2.305,1.375-2.305,1.369.3,1.369,2.305S19824.656,4284.729,19824.145,4284.729Zm-11.508-7.687c-.875,0-1.379-.84-1.379-2.306s.5-2.305,1.379-2.305,1.375.819,1.375,2.305S19813.523,4277.042,19812.637,4277.042Z" transform="translate(-19795.928 -4255.307)" fill="#0e3f92" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/> </svg>',
        welcomeHome: {
            incomeTaxDe: 'frei',
            descriptionEn:
                'Do you have any goods or services in your company that you offer for sale? Then offer them to your employees at a reduced price with the employee discount module.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Employee shopping discount',
            additionalityReq: false,
            maxAmountDe: 'bis zu  1.080 € pro Jahr',
            incomeTaxEn: 'free',
            descriptionDe:
                'Haben Sie in Ihrem Unternehmen selber Waren oder Dienstleistungen, die Sie zum Verkauf anbieten? Dann bieten Sie diese doch Ihren Mitarbeitern, mit dem Mitarbeiterrabatt-Baustein vergünstigt an.',
            legalBasis: '§ 8 Abs. 3 EStG',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Mitarbeitereinkaufsrabatt',
            maxAmountEn: 'up to €1,080 per year',
        },
    },
    {
        id: 'hardware',
        status: 'ACTIVE',
        nameDe: 'Handy-Baustein',
        nameEn: 'Hardware',
        descriptionDe:
            'Der Handy-Baustein ermöglicht Mitarbeitern die Nutzung von Smartphones zu circa 40% der marktüblichen Kosten.',
        descriptionEn:
            'The mobile phone module enables employees to use smartphones at around 40% of the usual market costs.',
        icon: 'assets%2Ficons%2Fservice-hardware.svg?alt=media&token=2782f77a-8b27-41f7-bbc5-8bfb0ba65ef7',
        iconSvg:
            '<svg xmlns="http://www.w3.org/2000/svg" width="85.545" height="133.29" viewBox="0 0 85.545 133.29">   <path id="ic_phone_android_24px" d="M69.857,1H22.688A17.7,17.7,0,0,0,5,18.767v94.756A17.7,17.7,0,0,0,22.688,131.29H69.857a17.7,17.7,0,0,0,17.688-17.767V18.767A17.7,17.7,0,0,0,69.857,1ZM58.065,119.445H34.481v-5.922H58.065Zm19.162-14.777H15.318v-85.9H77.227Z" transform="translate(-3.5 0.5)" fill="none" stroke="#103b91" stroke-width="3"/> </svg>',
        iconSvgFilled:
            '<svg xmlns="http://www.w3.org/2000/svg" width="82.545" height="130.289" viewBox="0 0 82.545 130.289">   <path id="ic_phone_android_24px" d="M69.857,1H22.688A17.7,17.7,0,0,0,5,18.767v94.756A17.7,17.7,0,0,0,22.688,131.29H69.857a17.7,17.7,0,0,0,17.688-17.767V18.767A17.7,17.7,0,0,0,69.857,1ZM58.065,119.445H34.481v-5.922H58.065Zm19.162-14.777H15.318v-85.9H77.227Z" transform="translate(-5 -1)" fill="#103b91"/> </svg>',
        welcomeHome: {
            incomeTaxDe: 'frei',
            descriptionEn:
                'A beautiful smartphone is fun. The mobile phone component enables your employees to use smartphones at around 40% of the usual market costs.',
            socialInsuranceDe: 'sozialversicherungs&shy;frei',
            aliasEn: 'Mobile phone rental',
            additionalityReq: false,
            maxAmountDe: 'unbegrenzt',
            incomeTaxEn: 'free',
            descriptionDe:
                'Ein schönes Smartphone macht Freude. Der Handy-Baustein ermöglicht Ihren Mitarbeitern, die Nutzung von Smartphones zu circa 40% der marktüblichen Kosten.',
            legalBasis: '§ 3 Nr. 45 EStG; R 3.45 LStR',
            socialInsuranceEn: 'social insurance free',
            aliasDe: 'Handyüberlassung',
            maxAmountEn: 'unlimited',
        },
    },
];

export const PARTNER_COMPANIES = [
    {
        name: 'ikea',
        image: '../assets/images/partners/ikea.png',
        imageAvif: '../assets/images/partners/ikea.avif',
        imageWebp: '../assets/images/partners/ikea.webp'
    },
    {
        name: 'media markt',
        image: '../assets/images/partners/mediamarket.jpg',
        imageAvif: '../assets/images/partners/mediamarket.avif',
        imageWebp: '../assets/images/partners/mediamarket.webp'
    },
    {
        name: 'adidas',
        image: '../assets/images/partners/adidas.png',
        imageAvif: '../assets/images/partners/adidas.avif',
        imageWebp: '../assets/images/partners/adidas.webp'
    },
    {
        name: 'rossmann',
        image: '../assets/images/partners/rossamann.jpg',
        imageAvif: '../assets/images/partners/rossamann.avif',
        imageWebp: '../assets/images/partners/rossamann.webp'
    },
    {
        name: 'c&a',
        image: '../assets/images/partners/ca.jpg',
        imageAvif: '../assets/images/partners/ca.avif',
        imageWebp: '../assets/images/partners/ca.webp'
    },
    {
        name: 'globetrotter',
        image: '../assets/images/partners/globetrotter.jpg',
        imageAvif: '../assets/images/partners/globetrotter.avif',
        imageWebp: '../assets/images/partners/globetrotter.webp'
    },
    {
        name: 'christ',
        image: '../assets/images/partners/chirst.jpg',
        imageAvif: '../assets/images/partners/chirst.avif',
        imageWebp: '../assets/images/partners/chirst.webp'
    },
    {
        name: 'douglas',
        image: '../assets/images/partners/douglas.jpg',
        imageAvif: '../assets/images/partners/douglas.avif',
        imageWebp: '../assets/images/partners/douglas.webp'
    },
    {
        name: 'toom baumarkt',
        image: '../assets/images/partners/toom.jpg',
        imageAvif: '../assets/images/partners/toom.avif',
        imageWebp: '../assets/images/partners/toom.webp'
    },
    {
        name: 'tchibo',
        image: '../assets/images/partners/tchibo.jpg',
        imageAvif: '../assets/images/partners/tchibo.avif',
        imageWebp: '../assets/images/partners/tchibo.webp'
    },
    {
        name: 'futterhaus',
        image: '../assets/images/partners/futterhaus.jpg',
        imageAvif: '../assets/images/partners/futterhaus.avif',
        imageWebp: '../assets/images/partners/futterhaus.webp'
    },
    {
        name: 'kaufland',
        image: '../assets/images/partners/kaufland.jpg',
        imageAvif: '../assets/images/partners/kaufland.avif',
        imageWebp: '../assets/images/partners/kaufland.webp'
    },
    {
        name: 'thalia',
        image: '../assets/images/partners/thalia.jpg',
        imageAvif: '../assets/images/partners/thalia.avif',
        imageWebp: '../assets/images/partners/thalia.webp'
    },
    {
        name: 'aral',
        image: '../assets/images/partners/aral.jpg',
        imageAvif: '../assets/images/partners/aral.avif',
        imageWebp: '../assets/images/partners/aral.webp'
    },
    {
        name: 'rewe',
        image: '../assets/images/partners/rewe.jpg',
        imageAvif: '../assets/images/partners/rewe.avif',
        imageWebp: '../assets/images/partners/rewe.webp'
    },
    {
        name: 'höffner',
        image: '../assets/images/partners/hoffner.jpg',
        imageAvif: '../assets/images/partners/hoffner.avif',
        imageWebp: '../assets/images/partners/hoffner.webp'
    },
    {
        name: 'total energies',
        image: '../assets/images/partners/totalenergies.jpg',
        imageAvif: '../assets/images/partners/totalenergies.avif',
        imageWebp: '../assets/images/partners/totalenergies.webp'
    },
    {
        name: 'penny',
        image: '../assets/images/partners/penny.png',
        imageAvif: '../assets/images/partners/penny.avif',
        imageWebp: '../assets/images/partners/penny.webp'
    },
    {
        name: 'h&m',
        image: '../assets/images/partners/hm.png',
        imageAvif: '../assets/images/partners/hm.avif',
        imageWebp: '../assets/images/partners/hm.webp'
    },
    {
        name: 'conrad',
        image: '../assets/images/partners/conrad.jpg',
        imageAvif: '../assets/images/partners/conrad.avif',
        imageWebp: '../assets/images/partners/conrad.webp'
    }
]
